import { BrowserRouter } from "react-router-dom";
import { observer } from "mobx-react";
import RouterProvider from "./provider/router-provider";
import "./styles/index.css";
import "./styles/devices.css";
import "./styles/PlayerCommunicationsPage.css";
import { userState } from "./state/UserState";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "./styles/index.css";
import "./styles/devices.css";
import "./styles/PlayerCommunicationsPage.css";
import { apiBaseUrl, UserStore, VENDOR } from ".";
import { AppColorsProvider } from "./provider/colors-provider";
import { VendorProvider } from "./provider/vendor-provider";
import { PEProgressBar } from "./components/linear-progress";

const BootLoader = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}
  >
    <PEProgressBar />
  </div>
);

const App = observer(() => {
  console.log("loading env => ", VENDOR);
  console.log("apiBaseUrl => ", apiBaseUrl);

  const baseUrl = document
    ?.getElementsByTagName("base")[0]
    ?.getAttribute("href")!;

  const queryClient = new QueryClient();

  return (
    <VendorProvider>
      <AppColorsProvider>
        <QueryClientProvider client={queryClient}>
          <UserStore.Provider value={userState}>
            {/* Gate rendering until the cached session has been validated, so an
                expired token can never flash authed UI before the redirect to login. */}
            {!userState.authChecked ? (
              <BootLoader />
            ) : (
              <BrowserRouter basename={baseUrl}>
                <RouterProvider />
              </BrowserRouter>
            )}
          </UserStore.Provider>
        </QueryClientProvider>
      </AppColorsProvider>
    </VendorProvider>
  );
});

export default App;
